import { useSnapshot } from 'valtio';
import rootStore from '~/store';
import authorizations, { type Action } from '.';

/** Whether the current user's org role allows `action`; false until the role has loaded. */
export function useActionPermission(action: Action): boolean {
  // `myRole` is read so the check reruns when the role lands.
  const { me, myRole } = useSnapshot(rootStore) as typeof rootStore;
  return !!me && !!myRole && authorizations.can(action);
}
